import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Session, User } from 'service';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import LoadingImage from '../../assets/loading.png'
import UnloadingImage from '../../assets/unloading.png'
import AttendanceImage from '../../assets/attendance.png'
import { app_version, clearCache } from 'service/Utils';
import ArthaGateway from 'service/ArthaGateway';

export const Dashboard = () => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Session>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (userData.profile) {
            setSession(userData.profile.profile);
        }
    }, [userData]);

    useEffect(() => {
        if (session != null) {
            loadProductionPlants();
            setIsLoading(false);
        }
    }, [session]);

    const loadProductionPlants = () => {
        let employeeId = session?.user?.id;
        if(employeeId && employeeId > 0) {
            ArthaGateway
                .getProductionPlants(employeeId)
                .then((data) => {
                    localStorage.setItem("production_plants", JSON.stringify(data));
                })
                .catch((error) => {
                    console.error("Error loading production plants:", error);
                });
        }
        setIsLoading(true);
    }

    return (
        <>
            <div className="page-dashboard">
                {isLoading &&
                    <Loader />
                }
                {!isLoading &&
                    <>
                        {session && session.user && session.user.name &&
                            <div className='page-header bg-dark' style={{ paddingBottom: "20px", marginBottom: "20px" }}>
                                Welcome,
                                <h2>{session?.user.name}</h2>
                            </div>
                        }
                        <div className='row'>
                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                <NavLink to="/loading">
                                    <div className="card">
                                        <img className="card-img-top" src={LoadingImage} alt="Card image cap"></img>
                                        <div className="card-body">
                                            <h5 className="card-title">Loading</h5>
                                        </div>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                <NavLink to="/unloading">
                                    <div className="card">
                                        <img className="card-img-top" src={UnloadingImage} alt="Card image cap"></img>
                                        <div className="card-body">
                                            <h5 className="card-title">Unloading</h5>
                                        </div>
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12 mb-4">
                                <div style={{ position: "relative", height: 50 }}>
                                    <div className='version-number'>
                                        <div className="btn btn-sm bg-dark" style={{ marginBottom: 10, color: "#fff", float: "left" }} onClick={clearCache}>Update to latest version</div>
                                        <span style={{ float: "right" }} >{app_version}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    );
};